/**
 * Semantic Shape Tokens — CSS variable references.
 */

export const borderRadius = {
  none: "var(--br-none)",
  base: "var(--br-base)",
  md: "var(--br-md)",
  lg: "var(--br-lg)",
  pill: "var(--br-pill)",
  full: "var(--br-full)",
} as const;
